import App from "@/views/App.vue";

export default [
  {
    path: "/novo-post",
    name: "newPost",
    component: App,
    redirect: { name: "newPostHome" },
    children: [
      {
        path: "/novo-post/:id?",
        name: "newPostHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewPost.vue"),
        meta: {
          displayName: "displayName.newPost",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-post/:id/:type?",
        name: "editPost",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditPost.vue"),
        meta: {
          displayName: "displayName.editPost",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-anuncio",
        name: "newAdvert",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewAdvert.vue"),
        meta: {
          displayName: "displayName.newAdvert",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-anuncio/:id",
        name: "editAdvert",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditAdvert.vue"),
        meta: {
          displayName: "displayName.editAdvert",
          requiresAuth: true,
        },
      },
    ],
  },
];
